import { ServicesGestoresService } from '@servicesGestores/services-gestores.service';
import { ServicesVisitasService } from '@servicesVisitas/services-visitas.service';
import { StorageKobraService } from './../core/http/storage-kobra/storage-kobra.service';
import { ServiciosBiService } from './../core/http/servicios-bi/servicios-bi.service';
import { SessionData } from './../shared/interfaces/session-data';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthService } from '../authentication/auth.service';
import { Router, Event as RouterEvent, ActivationEnd, NavigationEnd, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { LocalStorageService } from './../shared/services/local-storage.service';
import { Component, OnInit, ViewChild, ElementRef, inject } from '@angular/core';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { Menu } from './modelos/menu.model';
import { LayoutService } from './servicios/layout.service';
import { User } from "../user/user.model";
import { UserService } from "../user/user.service";
import { ApplicationService } from '../application/shared/application.service';
import { currentEnvironment } from '../../environments/current/current-environment';
import { environmentSelector } from '../../environments/environment.selector';
import { PermisosService } from 'src/app/application/shared/permisos.service';
import { ServiciosKobraService } from '@servicios/servicios-kobra.service';
import { Subscription, debounceTime, filter, fromEvent, map, tap, switchMap, of } from 'rxjs';
import { take } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiKobraService } from '../core/http/api-kobra/api-kobra.service';
import { ClientService } from '../core/http/client/client.service';
import { MobileKobraService } from '../core/http/mobile-kobra/mobile-kobra.service';
import { ServicesKobraService } from '../core/http/services-kobra/services-kobra.service';
import { ServiciosSaldosKobraService } from '../core/http/servicios-saldos-kobra/servicios-saldos-kobra.service';
import { CuentaService } from '../cuentas/shared/cuenta.service';
import { NotificationService } from '../dashboard-main/notification.service';
import { NewStorageKobraService } from '../core/http/new-storage-kobra/new-storage-kobra.service';
import { DescargasService } from './../descargas/descargas.service';
import { AuditoriaAccionesService } from '../auditoria/acciones/auditoria-acciones.service';
import { construirNombreAccion } from '../auditoria/acciones/auditoria-acciones.constants';

//import { ConsoleReporter } from 'jasmine';
//import { SidenavService } from './servicios/sidenav.service';
import {NotificationInterface} from '../dashboard-main/notification-interface'
import {NotificationTypes} from '../dashboard-main/notification-types'
import { Title } from '@angular/platform-browser';
import { TokenExpirationService } from '../authentication/token-expiration.service';
import { MatLabel } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { BreadcrumbComponent } from '../shared/components/breadcrumb/breadcrumb.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { MatNavList, MatListItem } from '@angular/material/list';
import { LoaderComponent } from '../shared/components/loader/loader.component';
import { NgClass } from '@angular/common';
import { LoadingComponent } from '../shared/components/loading/loading.component';
import { LoadingBarComponent } from '../shared/components/loading-bar/loading-bar.component';
import { SuperEjecutivoFlotanteComponent } from '../super-ejecutivo/super-ejecutivo-flotante/super-ejecutivo-flotante.component';
import { IDS_USUARIOS_PILOTO_SUPER_EJECUTIVO } from '../super-ejecutivo/super-ejecutivo.constants';
import { CambioPaisService } from '../shared/services/cambio-pais.service';
import { CatalogosService } from '../shared/services/catalogos.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    providers: [
        MatToolbar,
        LayoutService,
        UserService,
        ServiciosKobraService,
        CuentaService,
        NewStorageKobraService,
        DescargasService
    ],
    imports: [
        LoadingBarComponent,
        LoadingComponent,
        MatSidenavContainer,
        MatSidenav,
        NgClass,
        LoaderComponent,
        RouterLink,
        MatNavList,
        MatAccordion,
        MatListItem,
        RouterLinkActive,
        MatIcon,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatSidenavContent,
        MatToolbar,
        MatToolbarRow,
        MatIconButton,
        BreadcrumbComponent,
        MatMenuTrigger,
        MatTooltip,
        MatLabel,
        MatMenu,
        MatMenuItem,
        MatButton,
        RouterOutlet,
        SuperEjecutivoFlotanteComponent,
    ]
})
export class LayoutComponent implements OnInit {
  private environment = environmentSelector();
  private catalogos = inject(CatalogosService);
  private cambioPaisService = inject(CambioPaisService);

  @ViewChild(MatToolbar) toolbarMenu!: MatToolbar;
  @ViewChild('sidenav') sideNav!: MatSidenav;
  /** Área central y barra superior: el Super Ejecutivo se agranda al tamaño del área central (kia-en-kobra-admin, RN5). */
  @ViewChild(MatSidenavContent, { read: ElementRef, static: true }) areaCentral!: ElementRef<HTMLElement>;
  @ViewChild(MatToolbar, { read: ElementRef, static: true }) barraSuperior!: ElementRef<HTMLElement>;
  @ViewChild('menuList') menuListRef: ElementRef;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @ViewChild('menuApps') menuApps: any;

  //@ViewChild('sidenavRight', {static: false}) sidenavRight!: MatSidenav;
  sessionData: SessionData;
  mensajeCargando: string = 'Cargando...';
  mostrarCargando: boolean = false;
  sideAbierto: boolean = true;
  routerActual: any;
  menuItems: Menu[] = [];
  loading: boolean = false;
  loadingMenu: boolean = true;
  user: User;
  isAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  /** TEMPORAL: usuarios que ven el botón flotante del Super Ejecutivo durante el piloto (RN14 de super-ejecutivo-graficas). */
  readonly idsUsuariosPilotoSuperEjecutivo = IDS_USUARIOS_PILOTO_SUPER_EJECUTIVO;
  ocultarFooterLogo: boolean = true;
  showChildrenComponent = false;
  logo: String = 'assets/img/logo.png';
  logoUrl: String = '';
  hasNewNotifications: boolean = true;
  notifications: NotificationInterface[] = [];
  dropdownOpen: boolean = false;
  unreadNotifications: number = 0;
  notificationTypes = NotificationTypes;

  isDropdownOpen: boolean = false;


  logoDefault: String = 'assets/img/logo.png';
  imagenRota: boolean = false;
  dashAdminText: String;
  dashboardLink: String;
  paises = currentEnvironment.paises;
  paisActual = localStorage.getItem('paisSeleccionado') ? JSON.parse(localStorage.getItem('paisSeleccionado')) : currentEnvironment.paises[0];
  tamanioGrande: boolean = true;
  private esPrimero: boolean = true;
  private urlRoute: String = "";
  private mostrarLoading: Function;
  private ocultarLoading: Function;
  private subscription: Subscription;

  constructor(
    private rootElement: ElementRef,
    private router: Router,
    private localStorageService: LocalStorageService,
    private layoutService: LayoutService,
    private permisosService: PermisosService,
    private authService: AuthService,
    private app: ApplicationService,
    private lService: ServiciosKobraService,
    private apiKobraService: ApiKobraService,
    private clientService: ClientService,
    private mobileKobraService: MobileKobraService,
    private servicesKobraService: ServicesKobraService,
    private serviciosBiService: ServiciosBiService,
    private storageKobraService: StorageKobraService,
    private servicioVisitas: ServicesVisitasService,
    private servicesGestoresService: ServicesGestoresService,
    private serviciosSaldosKobraService: ServiciosSaldosKobraService,
    private cuentaService: CuentaService,
    private snackBar: MatSnackBar,
    private userService: UserService,
    private breakpointObserver: BreakpointObserver,
    //private sidenavService: SidenavService,
    private notificationService: NotificationService,
    private titleService: Title,
    private tokenExpirationService: TokenExpirationService,
    private newStorageKobraService: NewStorageKobraService,
    private descargasService: DescargasService,
    private auditoriaAccionesService: AuditoriaAccionesService
  ){
    this.user = new User();
    this.sessionData = this.localStorageService.getSessionData();
    this.router.events.subscribe((event: RouterEvent) => {
      if(this.esPrimero){
        this.esPrimero=false;
        this.urlRoute="";
      }
      if(event instanceof ActivationEnd && event.snapshot.routeConfig.path != ''){
        if(this.urlRoute){
          this.urlRoute=`${event.snapshot.routeConfig.path}/${this.urlRoute}`;
        }
        else{
          this.urlRoute=`${event.snapshot.routeConfig.path}`;
        }
      }

      if(event instanceof NavigationEnd && this.urlRoute != '' && !this.loadingMenu){
        this.esPrimero = true;
        this.validarMenu(`/${this.urlRoute}`);
      }
      else if(event instanceof NavigationEnd && this.urlRoute != ''){
        this.esPrimero = true;
      }
    });
    this.mostrarLoading = this.mostrarLoadingLocal.bind(this);
    this.ocultarLoading = this.ocultarLoadingLocal.bind(this);
  }

  private mostrarLoadingLocal(message: string){
    setTimeout(() => {
      this.mensajeCargando = message;
      this.mostrarCargando = true;
    }, 0);

  }

  private ocultarLoadingLocal(){
    setTimeout(() => {
      this.mostrarCargando = false;
    }, 0);
  }

  /**
   * Carga el logo de la financiera utilizando NewStorageKobraService
   * El proceso es:
   * 1. El servicio LayoutService obtiene la ruta del logo desde Visitas
   * 2. Luego usa esa ruta para obtener el blob de la imagen desde NewStorage
   * 3. Finalmente devuelve una URL de objeto para mostrar la imagen
   *
   * @param idFinanciera ID de la financiera
   * @param country Código del país
   */
  cargarLogo(idFinanciera: number, country: string) {
    if (this.isSuperAdmin) {
      this.logo = this.logoDefault;
      return;
    }

    this.layoutService.obtenerRutaLogo(idFinanciera, country).pipe(
      switchMap(response => {
        let rutaLogo = null;

        if (response && response.data) {
          if (response.data.logo) {
            rutaLogo = response.data.logo;
          }
        }

        if (rutaLogo) {
          const rutaCorrecta = this.newStorageKobraService.getLogoPath(rutaLogo);
          return this.newStorageKobraService.getFileByFullPathAsBlob(rutaCorrecta).pipe(
            map(blob => {
              if (blob) {
                const urlCreator = window.URL || window.webkitURL;
                return urlCreator.createObjectURL(blob);
              }
              throw new Error('No se pudo cargar la imagen del logo');
            })
          );
        }
        return of(null);
      })
    ).subscribe({
      next: (logoUrl) => {
        if (logoUrl) {
          this.logo = logoUrl;
          this.logoUrl = logoUrl;
          this.imagenRota = false;
        } else {
          this.logo = this.logoDefault;
          this.imagenRota = true;
        }
      },
      error: () => {
        this.logo = this.logoDefault;
        this.imagenRota = true;
      }
    });
  }

  ngOnInit(){
    this.loadUser();
    this.app.setFunciones(this.mostrarLoading, this.ocultarLoading);
    this.subscription = this.notificationService.notifications$.subscribe(
      (notifications) => {
          this.notifications = notifications;
          this.updateUnreadNotificationsCount();
      }
    );

  }



  ngOnDestroy() {
    if (this.subscription) {
        this.subscription.unsubscribe();
    }
  }

  downloadFile(notificacion: any, event: Event): void {
    event.stopPropagation(); // Esto previene que el evento clic se propague al botón padre

    const message = notificacion.mensaje;
    const fileNameMatch = message.match(/\"([^\"]+)\"/);
    const fileName = fileNameMatch ? fileNameMatch[1] : 'default_filename.xlsx';

    const idDescarga = notificacion.extraData?.idDescarga;

    if (!idDescarga) {
      console.error('Error: idDescarga no está definido en extraData.');
      this.snackBar.open('Error: No se pudo obtener el identificador de la descarga.', 'Cerrar', { duration: 3000 });
      return;
    }

    this.descargasService.descargarArchivo(idDescarga, fileName)
      .then(() => {
        this.markAsRead(notificacion);
      })
      .catch(error => {
        console.error('Error al descargar el archivo desde LayoutComponent:', error);
        let errorMessage = 'Error al descargar el archivo.';
        if (error && error.message) {
          errorMessage += ` Detalles: ${error.message}`;
        } else if (typeof error === 'string') {
          errorMessage += ` Detalles: ${error}`;
        }
        this.snackBar.open(errorMessage, 'Cerrar', { duration: 5000 });
      });
  }

  hasIdDescarga(extraData: any): boolean {
    return extraData && extraData.idDescarga;
  }


  updateUnreadNotificationsCount() {
    this.unreadNotifications = this.notifications.filter(n => !n.banLeida).length;
    if (this.unreadNotifications > 0) {
      this.titleService.setTitle(`Kobra Admin (${this.unreadNotifications})`);
    } else {
      this.titleService.setTitle(`Kobra Admin`);
    }
  }


  markAsRead(notification: any) {
    if(!notification.banLeida){
      this.notificationService.markNotificationAsRead(notification.idNotification);
    }
  }

  markAllNotificationsAsRead(): void {
     this.notificationService.markAllNotificationsAsRead();
  }

  toggleDropdown(): void {
      this.dropdownOpen = !this.dropdownOpen;
  }


  ngAfterViewInit() {

    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      if (result.matches) {
        this.sideNav.close();
        this.tamanioGrande = false;
      }
    });
    this.breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge
    ]).subscribe(result => {
      if (result.matches) {
        this.tamanioGrande = true;
      }
    });

    fromEvent(this.scrollContainer.nativeElement, 'scroll').pipe(
      debounceTime(100),
      filter(() => {
          const nativeElement = this.scrollContainer.nativeElement;
          return nativeElement.scrollTop + nativeElement.clientHeight >= nativeElement.scrollHeight;
      }),
      tap(() => {
          const currentCount = this.notifications.length;
          this.loadMoreNotifications(currentCount);
      })
  ).subscribe();
  }


  loadMoreNotifications(offset: number) {
    this.notificationService.loadNotifications(offset);
}


  /*toogleSidenav(){
    this.sidenavService.toogleSidenav();
  }*/
  manejarErrorImagen() {
    this.imagenRota = true;
    this.logo = this.logoDefault;
  }

  onImagenCargada() {
    this.imagenRota = false;
  }

  loadUser(){
    this.loading = true;
    let query = '?expand=admin'
    let userID = localStorage.getItem('userID');
    if (userID) {

      this.userService.getOne(+userID, query).subscribe(
        user => {
          let selectedCountry = localStorage.getItem('paisSeleccionado');
          let country = selectedCountry ? JSON.parse(selectedCountry).abreviacion : null;

          if (!country) {
            this.router.navigate(['/auth']);
            return;
          }

          this.isSuperAdmin = user.admin.isSuperAdmin;
          this.isAdmin = user.admin.isAdmin;
          this.user = user;
          localStorage.setItem('user', JSON.stringify(this.user));

          // Cargar el logo usando el nuevo método
          this.cargarLogo(user.admin.idFinanciera, country);

          this.loading = false;
          this.loadMenu(user);

          if( this.isSuperAdmin ) {
            this.dashAdminText = 'Admin';
            this.ocultarFooterLogo = true;
          } else {
            this.dashAdminText = 'Dashboard';
            this.ocultarFooterLogo = false;
          }
        }
      );
    }
  }

  loadMenu(user: User){
    this.loadingMenu = true;
    this.menuItems = [];

    if(this.mostrarCargando){
      this.mostrarCargando = false;
    }
    this.layoutService.getMenu().subscribe((menu: Array<Menu>) => {

      const queryStringToJSON = url => {
        const queryString = url.split('?')[1];

        if (!Boolean(queryString)) {
          return {};
        }

        const pairs = queryString.split('&');
        const result = {};

        pairs.forEach(pair => {
          pair = pair.split('=');
          result[pair[0]] = decodeURIComponent(pair[1] || '');
        });

        return JSON.parse(JSON.stringify(result));
      };

      let currentUri = window.location.pathname;
      const decodedCurrentUri = decodeURIComponent(currentUri);
      this.menuItems = menu.map((item: Menu) => {
        item.banExpandible = false;
        if (item.menuHijos && item.menuHijos.length>0) {
          item.banExpandible = item.menuHijos.some((men) => men.banVisible == true);
          item.menuHijos = item.menuHijos.map((item: Menu) => {
            // Validar que txtUrl no sea null antes de procesarlo
            if (item.txtUrl) {
              item.txtQueryParams = queryStringToJSON(item.txtUrl);
              item.txtUrl = item.txtUrl.split('?')[0];
            }

            return item;
          });

          return item;
        }

        // Validar que txtUrl no sea null antes de procesarlo
        if (item.txtUrl) {
          item.txtQueryParams = queryStringToJSON(item.txtUrl);
          item.txtUrl = item.txtUrl.split('?')[0];
        }

        return item;
      });
      this.loadingMenu = false;

      if(this.urlRoute){
        this.esPrimero = true;
        this.validarMenu(`/${this.urlRoute}`);
      }

      this.permisosService.guardarPermisos(this.menuItems);
      currentUri = window.location.pathname;
      for (let index = 0; index < this.menuItems.length; index++) {
        const menu: Menu = this.menuItems[index];
        if(menu.menuHijos && menu.menuHijos.length > 0){
          // Validar que txtUrl no sea null antes de usarlo en includes
          if(menu.menuHijos.some((menuValidar) => menuValidar.txtUrl && currentUri.includes(menuValidar.txtUrl))){
            menu.banExpandir = true;
          }
        }

      }
      setTimeout(() => {
        const activeLink = document.querySelector('.active-link');
        activeLink?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);

      this.showChildrenComponent = true;
    });

  }

  //Algún dia se unificara la sesion para le cambio de pais por ahora pos no
  cerrarSesion(): void{
    this.servicioVisitas.post('/logout', {})
      .pipe(
        take(1)
      ).subscribe(() => {
        this.notificationService.ngOnDestroy();
        this.tokenExpirationService.stopTokenExpirationChecker();
        localStorage.clear();
        localStorage.setItem('paisSeleccionado', JSON.stringify(this.paisActual));
        // Sin recarga de página la caché de catálogos sobrevive: la siguiente sesión no debe verla.
        this.catalogos.invalidarTodo();
        this.router.navigate(['/auth']);
    });
  }

  /**
   * Rutas públicas que no requieren validación de permisos
   */
  private readonly rutasPublicas: string[] = [
    '/auth',
    //'/login',
    //'/user'
  ];

  /**
   * Valida si una URL es una ruta pública
   */
  private esRutaPublica(url: string): boolean {
    return this.rutasPublicas.some(rutaPublica => {
      return url === rutaPublica || url.startsWith(rutaPublica + '/');
    });
  }

  validarMenu(url: string){
    // No validar rutas públicas
    if(this.esRutaPublica(url)){
      return;
    }

    if(this.menuItems && this.menuItems.length>0){
      // Usar el servicio de permisos que es más robusto
      if(!this.permisosService.getPermiso(url)){
        console.warn(`Acceso denegado a la ruta desde layout: ${url}`);
        this.app.showSnackbar(
          "Aviso",
          "No tienes permisos para acceder a esta sección",
          3000,
          "warning"
        );

        this.router.navigate(
          ['/'],
        {
          queryParams: {},
        });
      }
    }
  }

  obtenerPermisoMenu(menu: Menu[], url: string) : boolean{
    var respuesta = false;

    for (let index = 0; index < menu.length; index++) {
      const item = menu[index];

      if(item.menuHijos && item.menuHijos.length > 0){
        respuesta = this.obtenerPermisoMenu(item.menuHijos, url);
      }

      // Validar que txtUrl no sea null o undefined antes de usar trim()
      if(!respuesta && !item.banExpandible && item.txtUrl && item.txtUrl.trim() == url.trim()){
        respuesta = true;
      }

      if(respuesta){
        index = menu.length;
        return respuesta;
      }
    }
    return respuesta;
  }

  public filtrarPaises() {
    return this.paises.filter(pais => pais.nombre != this.paisActual.nombre);
  }

  public abrirMicrolearning(): void {
    const token = localStorage.getItem('access-token') || '';
    const url = `https://microlearning.kobra.red/api/auth/token-login?token=${encodeURIComponent(token)}`;
    window.open(url, '_blank');
  }

  public abrirKobraCoin(): void {
    const token = localStorage.getItem('access-token') || '';
    const url = `https://coins.kobra.red/?token=${encodeURIComponent(token)}`;
    window.open(url, '_blank');
  }

  public abrirCRM(): void {
    const token = localStorage.getItem('access-token') || '';
    const url = `https://crm.kobra.red/?token=${encodeURIComponent(token)}`;
    window.open(url, '_blank');
  }

  /*public cambioPais(pais){
    this.paisActual = pais;
    this.cerrarSesion(true);
  }*/


  //algun dia se podrá unificar la sesión bien por ahora seguira haciendo el merequetengue
  public cambioPais(pais){
    this.authService.reloadBaseUrl(pais.abreviacion);
    this.mostrarCargando = true;
    localStorage.setItem('paisSeleccionado', JSON.stringify(pais));
    this.authService.loginUpdate().subscribe(
      res => {
        // País, usuario, token, notificaciones y menú: lo mismo que al abrir un enlace de otro país.
        this.cambioPaisService.guardarSesion(pais, res.data);
        this.sessionData = this.localStorageService.getSessionData();
        this.paisActual = pais;
        this.notificationService.initSocket();

        if(!this.router.url || this.router.url == '/'){
          window.location.reload();
        }
        else{
          this.userService.reloadBaseUrl(this.paisActual.abreviacion);
          this.layoutService.reloadBaseUrl(this.paisActual.abreviacion);
          this.lService.reloadBaseUrl(this.paisActual.abreviacion);
          this.apiKobraService.reloadBaseUrl(this.paisActual.abreviacion);
          this.clientService.reloadBaseUrl(this.paisActual.abreviacion);
          this.mobileKobraService.reloadBaseUrl(this.paisActual.abreviacion);
          this.servicesKobraService.reloadBaseUrl(this.paisActual.abreviacion);
          this.serviciosBiService.reloadBaseUrl(this.paisActual.abreviacion);
          this.storageKobraService.reloadBaseUrl(this.paisActual.abreviacion);
          this.servicioVisitas.reloadBaseUrl(this.paisActual.abreviacion);
          this.servicesGestoresService.reloadBaseUrl(this.paisActual.abreviacion);
          this.serviciosSaldosKobraService.reloadBaseUrl(this.paisActual.abreviacion);
          this.cuentaService.reloadBaseUrl(this.paisActual.abreviacion);
          this.loadUser();
          this.router.navigate([''])/*.then(()=>{
            window.location.reload();
          })*/;
        }
      },
      err => {
        this.snackBar.open('No se pudo realizar el cambio de país', 'OK', {
          duration: 5000,
          panelClass: ['error']

        });
        this.mostrarCargando = false;
        this.authService.reloadBaseUrl(this.paisActual.abreviacion);
        localStorage.setItem('paisSeleccionado', JSON.stringify(this.paisActual));
        this.loading = false;
      }
    );
  }

  /**
   * Registra un click del menú lateral.
   * Envía nomAccion: "Categoría -> Opción" o solo la categoría.
   */
  public registrarClickMenu(p_nomCategoria: string, p_nomOpcion?: string): void {
    this.auditoriaAccionesService
      .registrarClickMenu({
        nomAccion: construirNombreAccion(p_nomCategoria, p_nomOpcion),
      })
      .pipe(take(1))
      .subscribe();
  }
}
